/**
 * Updates a url parameter with a new value
 * Replaces the current URL in the browser history
 *
 * @param key - The key of the URL parameter to replace
 * @param value - The value to replace the URL parameter with
 */
export const replaceUrlParam = (key: string, value: string) => {
  const url = new URL(window.location.href);
  url.searchParams.set(key, value);
  window.history.replaceState({}, '', url.toString());
};
